import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiDialogActions(theme: Theme): Components['MuiDialogActions'] {
  return {
    styleOverrides: {
      root: {
        padding: theme.spacing(0, 4, 4, 4),
        gap: theme.spacing(2),
        '& > :not(:first-of-type)': {
          marginLeft: 0,
        },
      },
    },
  };
}
